// import Data from "../../data/hiring_organizations.json";

import ComparisonWithOtherTable from "./ComparisonWithOtherTable";

function ComparisonWithOther() {
  return (
    <div className="comparison-with-other my-3 container text-center px-4">
      <div className="row mt-4 px-1 justify-content-center">
        <div className="head fs-6 fw-bold px-4 py-2 rounded section-tag text-center">
         
          <h2 style={{ fontSize: '32px', fontFamily: "'DM Serif Display', serif" }}><b>Why Logicmojo is your gateway to a successful </b><b style={{fontFamily: "'DM Serif Display', serif", color:"#9769ef" }}>Full Stack Development Career</b></h2>
        
        </div>
      </div>
      <ComparisonWithOtherTable />
    </div>
  );
}
export default ComparisonWithOther;
